import {Status, OperationModeSnapshot} from '@hconnect/common/types'
import {roundTo15MinIntervalStart} from '@hconnect/common/utils'
import {dataTestId} from '@hconnect/uikit'
import {HPTextField} from '@hconnect/uikit/src/lib2'
import {MenuItem} from '@mui/material'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {useCurrentTimeRounded} from '../../../../../../shared/hooks/useCurrentTimeRounded'
import {usePlantConfig} from '../../../../../../shared/hooks/usePlantConfigData'
import {ScheduleItem} from '../../../../../../shared/interfaces/api'
interface ScheduleItemOperationModeSelectProps {
  scheduleItem: ScheduleItem
  operationModes: OperationModeSnapshot[]
  handleOperationModeChange: (operationModeId: number, shouldSplit: boolean) => void
}
export const ScheduleItemOperationModeSelect: React.FC<ScheduleItemOperationModeSelectProps> = ({
  scheduleItem,
  operationModes: allOperationModes,
  handleOperationModeChange
}) => {
  const {t} = useTranslation()
  const {timezone_id: timezoneId} = usePlantConfig()
  const nowRounded = useCurrentTimeRounded({timezoneId, roundingFn: roundTo15MinIntervalStart})
  const {assetOperationModeId} = scheduleItem

  const isOperationModeChangeDisabled = moment.utc(scheduleItem.end).isBefore(nowRounded)
  const shouldDisplaySplitWarning = moment.utc(scheduleItem.start).isBefore(nowRounded)

  const onOperationModeChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    handleOperationModeChange(Number(e.target.value), shouldDisplaySplitWarning)

  // we need to filter out the Deleted operation modes in editable mode
  const operationModes = isOperationModeChangeDisabled
    ? allOperationModes
    : allOperationModes.filter((operationMode) => operationMode.status !== Status.Deleted)

  return (
    <HPTextField
      select
      label={t('planning.operationMode')}
      value={assetOperationModeId}
      fullWidth
      onChange={onOperationModeChange}
      variant="outlined"
      disabled={isOperationModeChangeDisabled}
      {...dataTestId('operation_mode_select')}
    >
      {operationModes.map((operationMode) => {
        return (
          <MenuItem
            key={`${operationMode.id}`}
            value={operationMode.id}
            {...dataTestId('operation_mode_item')}
          >
            {operationMode.name}
          </MenuItem>
        )
      })}
    </HPTextField>
  )
}
